import { Component, OnInit } from '@angular/core';
// sweet alert code start
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/app.constant';
import { CommonService } from 'src/app/service/common.service';
import { TableColumn } from 'src/app/interfaces/TableColumn';
import { EthicsCommitteeService } from 'src/app/service/ethics-committee.service';
import { MenuService } from 'src/app/service/menu.service';
// sweet alert code end

@Component({
  selector: 'app-ethics-committee',
  templateUrl: './ethics-committee.component.html',
  styleUrls: ['./ethics-committee.component.scss']
})
export class EthicsCommitteeComponent implements OnInit {

  public displayedColumns: TableColumn[] = [
    {
      name: 'ID',
      dataKey: 'id',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['id']}`,
    },
    {
      name: 'Ethics Committee',
      dataKey: 'name',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['name']}`,
    },
    {
      name: 'Project Name',
      dataKey: 'project_name',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['project_name']}`,
    },
    {
      name: 'Active',
      dataKey: 'status',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['status']}`,
    },
  ];

  public currentPage = 0;
  public data: any;
  public editLink: string = 'site/ethics-committee/edit/';
  public viewLink = 'site/ethics-committee/view/';
  public filterValue = '';
  public isApproved: number = 1;
  public loading: boolean = false;
  public pageSizeOptions: number[] = [10, 25, 50, 100];
  public pageSize = 10;
  public sortField = '';
  public sortOrder = '';
  public title = 'Ethics Committee Approvals';
  public totalRows = 0;
  public currentMenuPermission: any;

  constructor(
    private ethicsCommitteeService: EthicsCommitteeService,
    private commonService: CommonService,
    protected router: Router,
    private menuService: MenuService
  ) {}

  ngOnInit(): void {
    this.menuService.currentMenu.subscribe(currentMenu => {
      this.currentMenuPermission = currentMenu;
    });
    this.getAll();
  }

  /**
   * This function is used to get all Ethics Committee Listing
   * @author Farhan Shaikh
   */
  getAll() {
    this.loading = true;
    this.ethicsCommitteeService
      .getRecordByFilter(
        this.currentPage + 1,
        this.sortField,
        this.sortOrder,
        this.filterValue,
        this.pageSize,
        this.isApproved
      )
      .subscribe({
        next: (result: any) => {
          this.loading = false;
          this.data = result.data.data;
          this.totalRows = result.data.total;
        },
        error: (e) => {
          this.loading = false;
          console.log('Ethics Committee Listing err :: ', e);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  editAction(event: any) {
    this.router.navigate([this.editLink + event.id]);
  }

  onlyViewAction(event: any) {
    this.router.navigate([this.viewLink + event.id]);
  }

  /**
   * call Create Organ site api
   * @returns null
   */
  deleteProject(event: any) {
    Swal.fire({
      title: 'Delete?',
      html: 'Are you sure want to delete the Ethics Committee?',
      imageUrl: '../../../../../assets/images/delete.svg',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'btn mat-secoundary',
        cancelButton: 'btn mat-warn ml-1',
      },
    }).then((result) => {
      if (result.value) {
        this.ethicsCommitteeService.delete(event.id).subscribe({
          next: (result: any) => {
            if (result.status === AppConstants.serverSuccessStatus) {
              this.commonService.showSuccessToast(
                result.message
              );
              this.getAll();
            } else {
              this.commonService.showErrorToast(
                result.message
              );
            }
          },
          error: (e: any) => {
            this.commonService.showErrorToast('Ethics Committee not found');
          },
        });
      }
      if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  searchFilter(filterValue: any) {
    this.filterValue = filterValue;
    this.currentPage = 0;
    this.getAll();
  }
  SortFilter(sortState: any) {
    if (sortState.active !== '' && sortState.direction !== '') {
      this.sortField = sortState.active;
      this.sortOrder = sortState.direction;
    }else{
      this.sortField = '';
      this.sortOrder = '';
    }
      this.getAll();
  }
  pageChanged(event: any) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getAll();
  }
}
